import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "../../style/DashboardSecretaria.css";

const DashboardSecretaria = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <div className="secretaria-container">
      {/* HEADER */}
      <header className="secretaria-header">
        <div>
          <h2>📋 Panel Secretaria</h2>
          <p>
            Bienvenida, <strong>{user?.nombre}</strong>
          </p>
        </div>

      
      </header>

      {/* TARJETAS */}
      <div className="secretaria-grid">
        <div
          className="card"
          onClick={() => navigate("/secretaria/estudiantes")}
        >
          👩‍🎓
          <h3>Estudiantes</h3>
          <p> consultar estudiantes Con el numero de documento</p>
        </div>

        {/* <div
          className="card"
          onClick={() => navigate("/matricula")}
        >
          📝
          <h3>Matrículas</h3>
          <p>Gestionar matrículas del año activo</p>
        </div> */}

        <div
          className="card"
          onClick={() => navigate("/secretaria/certificaciones")}
        >
          📄
          <h3>Certificados</h3>
          <p>Generar certificados académicos</p>
        </div>

        <div
          className="card"
          onClick={() => navigate("/asistencia")}
        >
          📅
          <h3>Asistencia</h3>
          <p>Consultar asistencia por curso</p>
        </div>

        <div
          className="card"
          onClick={() => navigate("/informes")}
        >
          📊
          <h3>Informes</h3>
          <p>Reportes académicos y administrativos</p>
        </div>

        {/* <div
          className="card"
          onClick={() => navigate("/usuarios")}
        >
          👥
          <h3>Usuarios</h3>
          <p>Gestión de usuarios del sistema</p>
        </div> */}
      </div>
    </div>
  );
};

export default DashboardSecretaria;
